import I18N from 'assets/i18n/brandlift';
import brandliftTranslations from 'assets/i18n/brandlift-project';
import {
    Metric,
    MetricInfo,
    FilterGroup,
    FilterItem,
    CreateFormFields
} from 'client/common/types/brandlift/types';
import {BrandTypes} from 'client/common/store/reducers/context/types';

const i18n = I18N.brandliftStats;
const geoTranslations = brandliftTranslations.common.geo;

// https://a.yandex-team.ru/arc/trunk/arcadia/direct/perl/protected/Stat/Const.pm?rev=6497924#L250
export const FILTER_LIST: FilterGroup[] = [
    /* скрываем фильтр по частоте, он не готов
    {
        key: 'frequency',
        label: i18n.filter.frequency.label,
        values: [
            { key: '1', keyInApi: 'frequency', label: '1' },
            { key: '2', keyInApi: 'frequency', label: '2' },
            { key: '3+', keyInApi: 'frequency', label: '3+' }
        ]
    }, */
    {
        key: 'age',
        label: i18n.filter.age.label,
        values: [
            {key: '0', keyInApi: 'age', label: i18n.filter.age.values['0_17']},
            {key: '1', keyInApi: 'age', label: '18-24'},
            {key: '2', keyInApi: 'age', label: '25-34'},
            {key: '3', keyInApi: 'age', label: '35-44'},
            {key: '5', keyInApi: 'age', label: '45-54'},
            {key: '6', keyInApi: 'age', label: i18n.filter.age.values['55_99']}
        ]
    },
    {
        key: 'gender',
        label: i18n.filter.gender.label,
        values: [
            {key: '0', keyInApi: 'gender', label: i18n.filter.gender.values.male},
            {key: '1', keyInApi: 'gender', label: i18n.filter.gender.values.female}
        ]
    },
    {
        key: 'income',
        label: i18n.filter.income.label,
        values: [
            {key: 'A', keyInApi: 'bl_income', label: i18n.filter.income.values.low},
            {key: 'B', keyInApi: 'bl_income', label: i18n.filter.income.values.average},
            {key: 'C1', keyInApi: 'bl_income', label: i18n.filter.income.values.high},
            {key: 'C2', keyInApi: 'bl_income', label: i18n.filter.income.values.premium}
        ]
    },
    {
        key: 'geo',
        label: i18n.filter.geo.label,
        values: [
            // миллионники
            {key: '11235', keyInApi: 'geo_region', label: geoTranslations['11235']},
            {key: '11375', keyInApi: 'geo_region', label: geoTranslations['11375']},
            {key: '10842', keyInApi: 'geo_region', label: geoTranslations['10842']},
            {key: '10946', keyInApi: 'geo_region', label: geoTranslations['10946']},
            {key: '10645', keyInApi: 'geo_region', label: geoTranslations['10645']},
            {key: '10650', keyInApi: 'geo_region', label: geoTranslations['10650']},
            {key: '10658', keyInApi: 'geo_region', label: geoTranslations['10658']},
            {key: '38', keyInApi: 'geo_city', label: geoTranslations['38']},
            {key: '10950', keyInApi: 'geo_region', label: geoTranslations['10950']},
            {key: '10853', keyInApi: 'geo_region', label: geoTranslations['10853']},
            {key: '193', keyInApi: 'geo_city', label: geoTranslations['193']},
            {key: '10672', keyInApi: 'geo_region', label: geoTranslations['10672']},
            {key: '10243', keyInApi: 'geo_region', label: geoTranslations['10243']},
            {key: '54', keyInApi: 'geo_city', label: geoTranslations['54']},
            {key: '21949', keyInApi: 'geo_region', label: geoTranslations['21949']},
            {key: '10687', keyInApi: 'geo_region', label: geoTranslations['10687']},
            {key: '11266', keyInApi: 'geo_region', label: geoTranslations['11266']},
            {key: '11013', keyInApi: 'geo_region', label: geoTranslations['11013']},
            {key: '43', keyInApi: 'geo_city', label: geoTranslations['43']},
            {key: '10857', keyInApi: 'geo_region', label: geoTranslations['10857']},
            {key: '10693', keyInApi: 'geo_region', label: geoTranslations['10693']},
            {key: '11398', keyInApi: 'geo_region', label: geoTranslations['11398']},
            {key: '11020', keyInApi: 'geo_region', label: geoTranslations['11020']},
            {key: '11282', keyInApi: 'geo_region', label: geoTranslations['11282']},
            {key: '11070', keyInApi: 'geo_region', label: geoTranslations['11070']},
            {key: '10699', keyInApi: 'geo_region', label: geoTranslations['10699']},
            {key: '35', keyInApi: 'geo_city', label: geoTranslations['35']},
            {key: '10995', keyInApi: 'geo_region', label: geoTranslations['10995']},
            {key: '62', keyInApi: 'geo_city', label: geoTranslations['62']},
            {key: '11309', keyInApi: 'geo_region', label: geoTranslations['11309']},
            {key: '11158', keyInApi: 'geo_region', label: geoTranslations['11158']},
            {key: '10705', keyInApi: 'geo_region', label: geoTranslations['10705']},
            {key: '10174', keyInApi: 'geo_region', label: geoTranslations['10174']},
            {key: '10712', keyInApi: 'geo_region', label: geoTranslations['10712']},
            {key: '11403', keyInApi: 'geo_region', label: geoTranslations['11403']},
            {key: '213', keyInApi: 'geo_city', label: geoTranslations['213']},

            {key: '1', keyInApi: 'geo_region', label: geoTranslations['1']},
            {key: '10897', keyInApi: 'geo_region', label: geoTranslations['10897']},
            {key: '10176', keyInApi: 'geo_region', label: geoTranslations['10176']},
            {key: '11079', keyInApi: 'geo_region', label: geoTranslations['11079']},
            {key: '47', keyInApi: 'geo_city', label: geoTranslations['47']},
            {key: '10904', keyInApi: 'geo_region', label: geoTranslations['10904']},
            {key: '65', keyInApi: 'geo_city', label: geoTranslations['65']},
            {key: '11316', keyInApi: 'geo_region', label: geoTranslations['11316']},
            {key: '66', keyInApi: 'geo_city', label: geoTranslations['66']},
            {key: '11318', keyInApi: 'geo_region', label: geoTranslations['11318']},
            {key: '11084', keyInApi: 'geo_region', label: geoTranslations['11084']},
            {key: '10772', keyInApi: 'geo_region', label: geoTranslations['10772']},
            {key: '11095', keyInApi: 'geo_region', label: geoTranslations['11095']},
            {key: '11108', keyInApi: 'geo_region', label: geoTranslations['11108']},
            {key: '50', keyInApi: 'geo_city', label: geoTranslations['50']},
            {key: '11409', keyInApi: 'geo_region', label: geoTranslations['11409']},
            {key: '10926', keyInApi: 'geo_region', label: geoTranslations['10926']},
            {key: '11004', keyInApi: 'geo_region', label: geoTranslations['11004']},
            {key: '10231', keyInApi: 'geo_region', label: geoTranslations['10231']},
            {key: '11111', keyInApi: 'geo_region', label: geoTranslations['11111']},
            {key: '11330', keyInApi: 'geo_region', label: geoTranslations['11330']},
            {key: '11010', keyInApi: 'geo_region', label: geoTranslations['11010']},
            {key: '11012', keyInApi: 'geo_region', label: geoTranslations['11012']},
            {key: '11015', keyInApi: 'geo_region', label: geoTranslations['11015']},
            {key: '10933', keyInApi: 'geo_region', label: geoTranslations['10933']},
            {key: '10939', keyInApi: 'geo_region', label: geoTranslations['10939']},
            {key: '977', keyInApi: 'geo_region', label: geoTranslations['977']},
            {key: '11077', keyInApi: 'geo_region', label: geoTranslations['11077']},
            {key: '11117', keyInApi: 'geo_region', label: geoTranslations['11117']},
            {key: '11443', keyInApi: 'geo_region', label: geoTranslations['11443']},
            {key: '11021', keyInApi: 'geo_region', label: geoTranslations['11021']},
            {key: '11119', keyInApi: 'geo_region', label: geoTranslations['11119']},
            {key: '10233', keyInApi: 'geo_region', label: geoTranslations['10233']},
            {key: '11148', keyInApi: 'geo_region', label: geoTranslations['11148']},
            {key: '11340', keyInApi: 'geo_region', label: geoTranslations['11340']},
            {key: '39', keyInApi: 'geo_city', label: geoTranslations['39']},
            {key: '11029', keyInApi: 'geo_region', label: geoTranslations['11029']},
            {key: '10776', keyInApi: 'geo_region', label: geoTranslations['10776']},
            {key: '51', keyInApi: 'geo_city', label: geoTranslations['51']},
            {key: '11131', keyInApi: 'geo_region', label: geoTranslations['11131']},
            {key: '2', keyInApi: 'geo_city', label: geoTranslations['2']},
            {key: '11146', keyInApi: 'geo_region', label: geoTranslations['11146']},
            {key: '11450', keyInApi: 'geo_region', label: geoTranslations['11450']},
            {key: '11162', keyInApi: 'geo_region', label: geoTranslations['11162']},
            {key: '10795', keyInApi: 'geo_region', label: geoTranslations['10795']},
            {key: '10802', keyInApi: 'geo_region', label: geoTranslations['10802']},
            {key: '10819', keyInApi: 'geo_region', label: geoTranslations['10819']},
            {key: '11353', keyInApi: 'geo_region', label: geoTranslations['11353']},
            {key: '10832', keyInApi: 'geo_region', label: geoTranslations['10832']},
            {key: '11176', keyInApi: 'geo_region', label: geoTranslations['11176']},
            {key: '11153', keyInApi: 'geo_region', label: geoTranslations['11153']},
            {key: '172', keyInApi: 'geo_city', label: geoTranslations['172']},
            {key: '11457', keyInApi: 'geo_region', label: geoTranslations['11457']},
            {key: '11193', keyInApi: 'geo_region', label: geoTranslations['11193']},
            {key: '56', keyInApi: 'geo_city', label: geoTranslations['56']},
            {key: '11225', keyInApi: 'geo_region', label: geoTranslations['11225']},
            {key: '10841', keyInApi: 'geo_region', label: geoTranslations['10841']},
            {key: '11069', keyInApi: 'geo_region', label: geoTranslations['11069']},
            {key: '11024', keyInApi: 'geo_region', label: geoTranslations['11024']},
            {key: '10251', keyInApi: 'geo_region', label: geoTranslations['10251']},
            {key: '11156', keyInApi: 'geo_region', label: geoTranslations['11156']},
            {key: '11232', keyInApi: 'geo_region', label: geoTranslations['11232']}
        ]
    }
    /* скрываем фильтр по девайсам, слишком много вопросов из-за таргетинга PYTHIADEV-5101
    {
        key: 'device',
        label: i18n.filter.device.label,
        values: [
            {key: '1', keyInApi: 'device_groups', label: i18n.filter.device.values.desktop},
            {key: '2', keyInApi: 'device_groups', label: i18n.filter.device.values.mobile},
            {key: '3', keyInApi: 'device_groups', label: i18n.filter.device.values.tablets}
        ]
    }
    */
];

export const FILTER_ROWS = FILTER_LIST.reduce((acc: FilterItem[], item) => {
    return acc.concat(item.values);
}, []);

export const SUPPORTED_KEYS = new Set<string>();
FILTER_ROWS.map(item => SUPPORTED_KEYS.add(item.keyInApi));

export const SUPPORTED_VALUES = new Set<string>();
FILTER_ROWS.map(item => SUPPORTED_KEYS.add(item.key));

const i18nMetrics = I18N.metrics;

export const BRANDLIFT_METRIC_COUNT = 3;

export const MetricMap: {[name in Metric]: MetricInfo} = {
    adRecall: {
        name: 'adRecall',
        ...i18nMetrics.adRecall
    },
    brandAwareness: {
        name: 'brandAwareness',
        ...i18nMetrics.brandAwareness
    },
    purchaseIntent: {
        name: 'purchaseIntent',
        ...i18nMetrics.purchaseIntent
    },
    productConsideration: {
        name: 'productConsideration',
        ...i18nMetrics.productConsideration
    },
    brandFavorability: {
        name: 'brandFavorability',
        ...i18nMetrics.brandFavorability
    },
    adMessageRecall: {
        name: 'adMessageRecall',
        ...i18nMetrics.adMessageRecall
    }
};

export const BRANDLIFT_METRICS: MetricInfo[] = [
    MetricMap.brandAwareness,
    MetricMap.adRecall,
    MetricMap.purchaseIntent,
    MetricMap.productConsideration,
    MetricMap.brandFavorability,
    MetricMap.adMessageRecall
];

export const BRANDLIFT_AD_METRICS: MetricInfo[] = [
    MetricMap.adRecall,
    MetricMap.adMessageRecall
];

export const BRANDLIFT_BRAND_METRICS: MetricInfo[] = [
    MetricMap.brandAwareness,
    MetricMap.purchaseIntent,
    MetricMap.productConsideration,
    MetricMap.brandFavorability
];

export const METRIC_QUESTION_ORDER = BRANDLIFT_METRICS.map(({name}) => name);

export const FIELDS: CreateFormFields = {
    industry: {
        type: 'select',
        withInput: true,
        options: [
            I18N.industry.automotive,
            I18N.industry.realty,
            I18N.industry.telecom,
            I18N.industry.pharma,
            I18N.industry.finance,
            I18N.industry.entertainment,
            I18N.industry.fmcg,
            I18N.industry.hitech,
            I18N.industry.retail,
            I18N.industry.travel,
            I18N.industry.other
        ].map(value => ({value, label: value})),
        isRequired: true,
        withLock: false
    },
    brand: {
        type: 'text',
        isRequired: true,
        withLock: true
    },
    brandType: {
        type: 'radio',
        options: [BrandTypes.PRODUCT, BrandTypes.SERVICE],
        metrics: ['purchaseIntent', 'productConsideration'],
        defaultValue: BrandTypes.PRODUCT,
        withLock: true
    },
    brands: {
        type: 'text',
        multiple: true,
        minQuantity: 2,
        maxQuantity: 4,
        withLock: true
    },
    adMessage: {
        type: 'text',
        isRequired: true,
        metrics: ['adMessageRecall'],
        withLock: true
    },
    adMessages: {
        type: 'text',
        multiple: true,
        minQuantity: 2,
        maxQuantity: 4,
        metrics: ['adMessageRecall'],
        withLock: true
    }
};
